import { useState } from "react";
import { topics } from "@/mocks/home";

const sizeClass: Record<string, string> = {
  sm: "text-xs px-3 py-1.5",
  md: "text-sm px-4 py-2",
  lg: "text-base px-5 py-2.5",
};

const toneClass: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800 border-primary-200",
  accent: "bg-accent-100 text-accent-900 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-900 border-secondary-200",
};

export default function TopicWall() {
  const [active, setActive] = useState<string[]>([]);

  const toggle = (id: string) => {
    setActive((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  return (
    <section id="topics" className="border-b border-background-200/70 bg-background-50">
      <div className="px-4 py-12 md:px-10 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-accent-700">
              <i className="ri-price-tag-3-line text-base"></i>
              TOPIC WALL
            </div>
            <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
              话题墙 · 大家都在聊什么
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              点击标签即可筛选关注的方向，从完整版入口到剧情解读，按兴趣聚焦内容。
            </p>
          </div>

          {active.length > 0 && (
            <button
              type="button"
              onClick={() => setActive([])}
              className="flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-refresh-line"></i>
              清除筛选（{active.length}）
            </button>
          )}
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-2.5 border-t border-background-200/70 pt-8">
          {topics.map((topic) => {
            const isActive = active.includes(topic.id);
            return (
              <button
                key={topic.id}
                type="button"
                onClick={() => toggle(topic.id)}
                className={`flex cursor-pointer items-center gap-2 rounded-full border transition-colors ${
                  sizeClass[topic.size]
                } ${
                  isActive
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : `${toneClass[topic.tone]} hover:border-primary-300`
                }`}
              >
                <span className="font-medium">{topic.label}</span>
                <span className={isActive ? "text-background-50/80" : "opacity-60"}>
                  {topic.count}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}